import React, { useEffect } from 'react';
import { useFieldArray, useWatch } from 'react-hook-form';
import classnames from 'classnames';
import Field from './Field';
import KPISwitch from './KPISwitch';
import KPITypeSelect from './KPITypeSelect';
import KPIFormatSelect from './KPIFormatSelect';
import KPILeanSelect from './KPILeanSelect';
import styles from './KPIFieldset.module.css';

function KPIFieldset({ name, value, options }) {
  const { fields: datasets, append: appendDataset } = useFieldArray({ name: 'state.datasets' });
  const { fields: scales, append: appendScale } = useFieldArray({ name: 'state.scales' });
  const datasetIndex = value ? datasets.findIndex((dataset) => dataset.key === value.name) : -1;
  const dataset = useWatch({ name: `state.datasets.${datasetIndex}` });

  useEffect(() => {
    if (dataset) {
      return;
    }

    appendDataset({
      key: value.name,
      type: 'line',
      label: value.name,
      xAxis: 'x',
      yAxis: 'y',
      disabled: false
    });
  }, [appendDataset, dataset, value]);

  useEffect(() => {
    if (!dataset) {
      return;
    }

    const { yAxis } = dataset;

    const scale = scales.find((scale) => scale.key === yAxis);

    if (scale) {
      return;
    }

    const position = scales.some(({ position }) => position === 'left') ? 'right' : 'left';

    appendScale({ key: yAxis, label: '', position });
  }, [appendScale, dataset, scales]);

  return (
    <div
      className={classnames(styles.root, {
        [styles.disabled]: !value
      })}
    >
      <Field
        name={`state.datasets.${datasetIndex}.disabled`}
        defaultValue={false}
        className={styles.switch}
        input={KPISwitch}
      />
      <Field name={`${name}.name`} options={options} disabled={dataset?.disabled ?? false} input={KPITypeSelect} />
      <Field
        name={`state.datasets.${datasetIndex}.type`}
        defaultValue="line"
        disabled={dataset?.disabled ?? false}
        className={styles.format}
        input={KPIFormatSelect}
      />
      <Field
        name={`state.datasets.${datasetIndex}.yAxis`}
        defaultValue="y"
        disabled={dataset?.disabled ?? false}
        className={styles.lean}
        input={KPILeanSelect}
      />
    </div>
  );
}

export default KPIFieldset;
